/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 */
import domReady from "@wordpress/dom-ready"; // Ensures the DOM is fully loaded before executing the function
import ReactDOM from "react-dom"; // Allows rendering React components to the DOM
import ChineseZodiacCalculator from "./files/chinese-zodiac-calculator.js"; // Imports the ChineseZodiacCalculator React component
import renderChineseSign from "./files/chinese-zodiac-result.js"; // Imports the function to render the Chinese zodiac result
import React from "react"; // Imports React

// Wait until the DOM is fully loaded
domReady(function () {

	// Check if the element with id 'form-zodiac' exists in the DOM
	const formZodiac = document.getElementById("form-zodiac");
	if (formZodiac) {
		// If the element exists, render the ChineseZodiacCalculator React component inside this element
		ReactDOM.render(<ChineseZodiacCalculator />, formZodiac);
	}

	// Check if the element with id 'chinese-astrology-calculator-form' exists in the DOM
	const chineseZodiacForm = document.getElementById("chinese-astrology-calculator-form");
	if (chineseZodiacForm) {
		// If the element exists, add a submit event listener to the form
		chineseZodiacForm.addEventListener("submit", function (event) {
			// Prevent the default form submission behavior
			event.preventDefault();

			// Call the function to render the Chinese zodiac result
			renderChineseSign();
		});
	}

	// Check if the element with id 'dateOfBirth' exists in the DOM
	const dateOfBirthElement = document.getElementById('dateOfBirth');
	// Check if the element with id 'birthYear' exists in the DOM
	const birthYearSelect = document.getElementById('birthYear');

	// If the 'dateOfBirth' element exists, add a click event listener to it
	if (dateOfBirthElement) {
		dateOfBirthElement.addEventListener('click', function () {
			// When 'dateOfBirth' is clicked, set focus on the 'birthYear' select element
			birthYearSelect.focus();
		});
	}
});
